export const tableColumn = [
	{
		label: '客户号',
		prop: 'customerId',
		width: '120px',
		fixed: true,
	},
	{
		label: '客户名',
		prop: 'customerName',
		width: '120px',
	},

	{
		label: '还款日期(每月?日)',
		prop: 'remindTime',
		width: '200px',
	},
	{
		label: '起始日期',
		prop: 'startTime',
	},
	{
		label: '结束日期',
		prop: 'endTime',
	},
	{
		label: '备注',
		prop: 'content',
	},
	{
		label: '创建时间',
		prop: 'createTime',
	},
	{
		label: '操作',
		prop: 'id',
		width: '100px',
		isCustomize: true,
		tableType: 'workReport',
		fixed: 'right',
	},
]

export const forms = [
	[
		{
			label: '客户号',
			type: 'inputNumber',
			attr: 'customerId',
			column: 12,
			labelWidth: '200px',
		},
		{
			label: '还款日期(每月)',
			type: 'inputNumber',
			attr: 'remindTime',
			column: 12,
			labelWidth: '200px',
		},
	],
	[
		{
			label: '起始日期',
			type: 'date',
			attr: 'startTime',
			placeholder: '请选择',
			column: 12,
			labelWidth: '200px',
			valueFormat: 'YYYY-MM-DD',
		},
		{
			label: '结束日期',
			type: 'date',
			attr: 'endTime',
			placeholder: '请选择',
			column: 12,
			labelWidth: '200px',
			valueFormat: 'YYYY-MM-DD',
		},
	],
	[
		{
			label: '备注',
			type: 'input',
			inputType: 'textarea',
			attr: 'content',
			placeholder: '请输入备注',
			column: 24,
			labelWidth: '200px',
		},
	],
]
